/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Editors_Pain_Saved_EditInputs */

const en_us2_profile_editors_pain_saved_edit = /** @type {(inputs: Profile_Editors_Pain_Saved_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pain updated`)
};

const pt_br2_profile_editors_pain_saved_edit = /** @type {(inputs: Profile_Editors_Pain_Saved_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dor atualizada`)
};

const es_419_profile_editors_pain_saved_edit = /** @type {(inputs: Profile_Editors_Pain_Saved_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dolor actualizado`)
};

const pt_pt2_profile_editors_pain_saved_edit = /** @type {(inputs: Profile_Editors_Pain_Saved_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dor atualizada`)
};

const fr_fr2_profile_editors_pain_saved_edit = /** @type {(inputs: Profile_Editors_Pain_Saved_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Douleur mise à jour`)
};

const de_de2_profile_editors_pain_saved_edit = /** @type {(inputs: Profile_Editors_Pain_Saved_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schmerz aktualisiert`)
};

const it_it2_profile_editors_pain_saved_edit = /** @type {(inputs: Profile_Editors_Pain_Saved_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dolore aggiornato`)
};

/**
* | output |
* | --- |
* | "Pain updated" |
*
* @param {Profile_Editors_Pain_Saved_EditInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_editors_pain_saved_edit = /** @type {((inputs?: Profile_Editors_Pain_Saved_EditInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Editors_Pain_Saved_EditInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_editors_pain_saved_edit(inputs)
	if (locale === "es-419") return es_419_profile_editors_pain_saved_edit(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_editors_pain_saved_edit(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_editors_pain_saved_edit(inputs)
	if (locale === "de-DE") return de_de2_profile_editors_pain_saved_edit(inputs)
	if (locale === "it-IT") return it_it2_profile_editors_pain_saved_edit(inputs)
	return en_us2_profile_editors_pain_saved_edit(inputs)
});
export { profile_editors_pain_saved_edit as "profile-editors.pain_saved_edit" }